<template>
    <div v-if="visible" class="wcag-contrast-chooser">
        <ul>
            <li v-for="color in colors">
                <a href="#" :class="'btn btn-contrast'" :style="style(color)" @click="changeContrast(color)">
                    <span aria-hidden="true">A</span>
                    <span class="sr-only">{{ $lang('Wybierz kolor') }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import {EventBus} from '../mixins/event-bus';

    export default {
        name: "theme-selector",
        created() {
            if(this.default_color) {
                this.changeContrast(this.default_color);
            } else {
                // if (localStorage.contrast) {
                //     this.changeContrast(localStorage.contrast)
                // }
            }
        },
        data: function() {
            return {
                colors: [
                    '#00a8f1',
                    '#5FBFF9',
                    '#52DEE5',
                    '#4D9078',
                    '#36827F',
                    '#B4436C',
                    '#985277',
                    '#8C1A6A',
                    '#70798C',
                    '#383B53',
                    '#2F2963',
                    '#191D32',
                    '#070707',
                ]
            }
        },
        props: {
            visible: {
                type: Boolean,
                required: false,
                default: false
            },
            default_color: {
                type: String,
                required: false,
                default: null
            }
        },
        methods: {
            saveContrast(contrast) {
                localStorage.contrast = contrast;
            },
            changeContrast(contrast) {
                //this.saveContrast(contrast);
                document.querySelector(':root').style.setProperty('--primary-to-yellow', contrast);
                document.querySelector(':root').style.setProperty('--primary-to-black', contrast);
                document.querySelector(':root').style.setProperty('--footer-background', contrast);
                EventBus.$emit('contrastChange', contrast);
            },
            style(color) {
                return 'background-color: ' + color + '; color: #fff';
            }
        }
    };
</script>
